import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import PageHeader from '../../../../components/PageHeader/PageHeader';

function BookingInfo({ disabled }) {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const booking = formik.values?.booking;



  // Safe formatter to avoid rendering objects as React children
  const formatValue = (v) => {
    if (v == null) return '-';
    if (v instanceof Date) return v.toLocaleDateString();
    if (typeof v === 'object') {
      if (typeof v.name === 'string') return v.name;
      if (typeof v.number === 'string' || typeof v.number === 'number') return String(v.number);
      return '-';
    }
    return String(v);
  };

  const details = [
    { label: t('Destination'), value: booking?.destination?.name },
    { label: t('PortLoading'), value: booking?.portLoading?.name },
    { label: t('ShippingLine'), value: booking?.shippingLine?.name },
    { label: t('VesselName'), value: booking?.vesselName },
    { label: t('VoyageNumber'), value: booking?.voyageNumber },
    { label: t('pickupTerminal'), value: booking?.pickupTerminal?.name },
    { label: t('returnTerminal'), value: booking?.returnTerminal },
    { label: t('Estimated Sailing Date'), value: booking?.estimatedSailingDate },
    { label: t('Estimated Arrival Date'), value: booking?.estimatedArrivalDate },
    { label: t('Earliest Receiving Date'), value: booking?.earliestReceivingDate },
    { label: t('Latest Return Date'), value: booking?.latestReturnDate },
    { label: t('DOC Cutoff Date'), value: booking?.cutoffDate },
    { label: t('Booking Note'), value: booking?.note },
  ].filter(d => d.value != null && d.value !== '');

  return (
    <>
      <PageHeader title={t('Booking Information')} />

   

      {/* Details */}
      {booking && (
        <Box sx={{ px: { xs: 0, md: 3 }, mt: { xs: 2, md: 3 } }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 3 },
              border: '1px solid #e5eaef',
              borderRadius: 2,
              bgcolor: '#fff',
            }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(auto-fill, minmax(220px, 1fr))',
                  sm: 'repeat(auto-fill, minmax(240px, 1fr))',
                  md: 'repeat(4, 1fr)',
                },
                gap: { xs: 1.5, md: 2 },
              }}
            >
              {details.map((d, i) => (
                <Box
                  key={`${d.label}-${i}`}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: 'text.secondary', mb: 0.5, whiteSpace: 'nowrap' }}
                  >
                    {d.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: '#0B3C5D',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={formatValue(d.value)}
                  >
                    {formatValue(d.value)}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Divider and primary info row */}
            <Divider sx={{ my: { xs: 2, md: 3 } }} />
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
                gap: 2,
              }}
            >
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {t('Booking Number')}
                </Typography>
                <Typography variant="h6" sx={{ m: 0, color: '#0B3C5D' }}>
                  {formatValue(booking?.number)}
                </Typography>
              </Box>
              <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {t('Status')}
                </Typography>
                <Typography variant="h6" sx={{ m: 0, color: '#0B3C5D' }}>
                  {formatValue(booking?.status ?? booking?.bookingStatus)}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
}

export default BookingInfo;